<template>
    <Card :title="$t('labels.apiCredential')">
        <div class="card-body">
            <div class="row">
                <FormGroup :label="$t('labels.name')" class="col-lg-6">
                    <Input v-model="name"/>
                </FormGroup>
                <FormGroup :label="$t('labels.service')" class="col-lg-6">
                    <AppSelect
                        @update:model-value="service = $event"
                        :model-value="service?.key"
                        :selected-value="service?.name"
                        :options="integrationServices"
                        option-key="key"
                        option-value="name"
                    />
                </FormGroup>
            </div>
            <component
                v-if="serviceComponent"
                :is="serviceComponent"
                :key="service.key"
                ref="serviceFields"
            />
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton color="indigo" :disabled="!serviceComponent" @click="createApiCredentials()">
                <i class="icon-floppy-disk mr-2"></i>
                {{ $t('buttons.create') }}
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FormGroup from '../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../components/new/form/Input.vue';
import AppSelect from '../../../../components/new/form/select/AppSelect.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';

import { apiCredentialServiceComponents } from './apiCredentialServiceComponents';
import { httpClient } from '../../../../services/HttpClient';

export default {
    name: "CreateApiCredentialsPage",
    components: {
        Card, FormGroup, Input, AppSelect, AppButton
    },
    data() {
        return {
            name: '',
            service: null,
            integrationServices: Object.keys(apiCredentialServiceComponents).map(key => ({
                key,
                name: this.$t(`integrationServices.${key}`)
            }))
        }
    },
    computed: {
        serviceComponent() {
            let serviceComponent = apiCredentialServiceComponents[this.service?.key] ?? null;

            return serviceComponent;
        }
    },
    methods: {
        async createApiCredentials() {
            let request = {
                name: this.name,
                type: this.service.key,
                ...this.$refs.serviceFields.buildRequest()
            };

            await httpClient.post(`/projects/${this.$route.params.projectUuid}/core/api-credentials`, request).then(() => {
                this.$router.replace({
                    name: 'ApiCredentialsPage'
                })
            })
        }
    }
}
</script>
